var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header_area"},[_c('div',{staticClass:"container-flow"},[_c('nav',{staticClass:"navbar navbar-expand-lg navbar-light"},[_c('router-link',{staticClass:"navbar-brand logo_h",attrs:{"tag":"div","to":{name: 'Hello'},"activeClass":"active","exact":""}},[_c('img',{attrs:{"src":_vm.logolarge,"alt":"","height":"60"}})])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-274b1065","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderV2.vue
// module id = EMnp
// module chunks = 1